<template>
  <div class="bar_wrap">
    <div ref="barcharts" id="barcharts" class="barcharts"></div>
  </div>
</template>
<script>
import echarts from 'echarts'


export default {
  props: {
    marks: {
      type: Number
    },
  },
  data () {
    return {
    }
  },
  watch: {
    marks (curVal, oldVal) {
      this.initCharts()
    },
  },
  methods: {
    initCharts () {
      let charts = this.$echarts.init(this.$refs.barcharts);

      var option = {
        series: [
          {
            name: '业务指标',
            type: 'gauge',
            center: ["47%", "40%"], // 仪表位置
            radius: "80%", //仪表大小
            radius: 90, //半径
            //仪表盘轴线相关配置。
            axisLine: {
              show: false,//将图表轴线、label、分割线、隐藏，只保留刻度
              // lineStyle: {
              //   color: [
              //     [1, '#5ac3ff']
              //   ],
              //   width: 3,//表盘宽度
              //   opacity: 1
              // }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: true,// 是否显示仪表盘轴线(轮廓线),默认 true。
              lineStyle: { // 属性lineStyle控制线条样式
                shadowBlur: 1,             //(发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。 
                shadowColor: "#fff",        //阴影颜色。支持的格式同color。
                color: '#5ac3ff',
                width: 2//表盘宽度
              }
            },
            axisLabel: {
              show: false
            },
            pointer: { //指针样式
              length: '45%'
            },
            detail: {
              show: false
            }
          },

          {
            type: 'gauge', // 仪表盘
            data: [{
              value: this.marks,
              name: '分数',

            }],
            radius: "90%", //仪表大小
            radius: 98, //半径
            splitNumber: 4,
            min: -100,
            max: 100,
            detail: {
              offsetCenter: [0, "60%"],    //设置仪表盘下方显示内容位置
              formatter: '{value}',
              textStyle: { color: '#379ee9', fontSize: 60, fontWeight: 600 },
            },
            title: {               //设置仪表盘中间显示文字样式
              offsetCenter: [0, '-60%'],//设置完成率位置
              borderColor: '#ccc', //标题边框颜色,默认'#ccc'
              textStyle: {       // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                fontWeight: 'bolder',
                fontSize: 20,
                fontStyle: 'italic',
                color: "#379ee9",

              },
              left: '100%',
            },
            center: ["47%", "40%"], // 默认全局居中

            axisLine: {       //y轴
              show: false

            },
            splitLine: {     //网格线
              show: false
            },
            axisTick: {
              show: false
            },
            pointer: {              // 仪表盘指针。
              show: true,             // 是否显示指针,默认 true。
              length: "50%",          // 指针长度，可以是绝对数值，也可以是相对于半径的百分比,默认 80%。
              width: 8,               // 指针宽度,默认 8。
            },

            axisLine: {
              show: true,// 是否显示仪表盘轴线(轮廓线),默认 true。
              lineStyle: { // 属性lineStyle控制线条样式
                shadowBlur: 1,             //(发光效果)图形阴影的模糊大小。该属性配合 shadowColor,shadowOffsetX, shadowOffsetY 一起设置图形的阴影效果。 
                shadowColor: "#fff",        //阴影颜色。支持的格式同color。
                color: [ //表盘颜色
                  [0.25, "#6EEFFF"],//0-50%处的颜色
                  [0.5, "#4DC5F7"],//51%-70%处的颜色
                  [0.75, "#3AA5FB"],//70%-90%处的颜色
                  [1, "#1A83D8"]//90%-100%处的颜色
                ],
                width: 16//表盘宽度
              }
            },
            axisLabel: { //文字样式（及“10”、“20”等文字样式）
              // formatter: function (e) {
              //   console.log(e)
              //   // switch (e + "") {
              //   //   case "10":
              //   //     return "0.2";
              //   // }
              // },
              color: [ //表盘颜色
                [0.25, "#6EEFFF"],//0-50%处的颜色
                [0.5, "#4DC5F7"],//51%-70%处的颜色
                [0.75, "#3AA5FB"],//70%-90%处的颜色
                [1, "#1A83D8"]//90%-100%处的颜色
              ],
              distance: -50 //文字离表盘的距离
            },
          }
        ]
      }
      charts.setOption(option);

    }
  },
  created () {
    this.$nextTick(() => {
      this.initCharts()
    })
  }
}
</script>
<style lang="scss" scoped>
.barcharts {
  width: 700px;
  height: 610px;
}
</style>